var map = {
	"./DSCF0470.jpg": 7723,
	"./DSCF0471.jpg": 9678,
	"./DSCF0476.jpg": 5301,
	"./DSCF0477.jpg": 984,
	"./DSCF0483.jpg": 7533,
	"./DSCF0502.jpg": 3693,
	"./DSCF0859.jpg": 2236,
	"./DSCF0868.jpg": 2264,
	"./DSCF0872.jpg": 6237,
	"./DSCF0885.jpg": 7159,
	"./DSCF0901.jpg": 9790,
	"./DSCF2857.JPG": 9425,
	"./DSCF2858.JPG": 7834,
	"./DSCF2862.JPG": 6341,
	"./DSCF2863.JPG": 4664,
	"./DSCF2867.JPG": 9228,
	"./DSCF2874.jpg": 8461,
	"./DSCF2886.jpg": 8434,
	"./DSCF2896.jpg": 5869,
	"./DSCF2908.jpg": 5433,
	"./DSCF2909.jpg": 7644,
	"./IMG-20261013-WA0004.jpg": 2276,
	"./IMG-20261013-WA0005.jpg": 4081,
	"./IMG-20261013-WA0018.jpg": 6439,
	"./IMG-20261013-WA0020.jpg": 1290,
	"./IMG-20261013-WA0021.jpg": 3447,
	"./IMG-20261013-WA0024.jpg": 8366,
	"./IMG-20261013-WA0027.jpg": 3385,
	"./IMG-20261013-WA0028.jpg": 4114,
	"./IMG-20261013-WA0030.jpg": 7617,
	"./IMG-20261013-WA0043.jpg": 1355,
	"./IMG-20261022-WA0007.jpg": 1035,
	"./IMG-20261022-WA0008.jpg": 9280,
	"./escalda-pes.jpg": 8386,
	"./limpeza_pele.jpg": 6357,
	"./massagem-chocolate.jpg": 6053,
	"./massagem-relaxante.jpg": 4521
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9053;